import VueRouter from 'vue-router';
import Vue from 'vue';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var assign = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length < 2) {
        return args[0];
    }
    var target = args.shift();
    var sources = args;
    if (!target || typeof target !== 'object') {
        return target;
    }
    if (typeof Object.assign === 'function') {
        return Object.assign.apply(Object, __spreadArray([target], sources, false));
    }
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        if (!source || typeof source !== 'object') {
            continue;
        }
        for (var _b = 0, _c = Object.keys(source); _b < _c.length; _b++) {
            var key = _c[_b];
            target[key] = source[key];
        }
    }
    return target;
};

var castArray = function (arg) {
    var value = arg;
    if (!value || typeof value !== 'object') {
        return [value];
    }
    if (Array.isArray(value)) {
        return value;
    }
    if ('length' in value && typeof value.length === 'number') {
        return Array.from(value);
    }
    // @ts-ignore
    if (Symbol.iterator in value && typeof value[Symbol.iterator] === 'function') {
        return Array.from(value);
    }
    return [value];
};

var defaults = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length < 2) {
        return args[0];
    }
    var target = args.shift();
    var sources = args;
    if (sources.length === 0) {
        return target;
    }
    if (!target || typeof target !== 'object') {
        return target;
    }
    if (typeof Object.assign === 'function') {
        if (sources.length > 1) {
            sources = [Object.assign.apply(Object, __spreadArray([{}], sources, false))];
        }
    }
    for (var _b = 0, sources_1 = sources; _b < sources_1.length; _b++) {
        var source = sources_1[_b];
        if (!source || typeof source !== 'object') {
            continue;
        }
        for (var _c = 0, _d = Object.keys(source); _c < _d.length; _c++) {
            var key = _d[_c];
            (_a = target[key]) !== null && _a !== void 0 ? _a : (target[key] = source[key]);
        }
    }
    return target;
};

var findLastIndex = function (array, predicate) {
    if (typeof predicate !== 'function') {
        return -1;
    }
    if (!Array.isArray(array)) {
        return -1;
    }
    for (var i = array.length - 1; i >= 0; i -= 1) {
        if (predicate(array[i], i, array)) {
            return i;
        }
    }
    return -1;
};

// dotted sperate path
var toPath = function (value) {
    return value.split(/\s*\.\s*/);
};

var hasOwn$1 = Object.prototype.hasOwnProperty;
var has = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var target = args[0], key = args[1];
    var result = target;
    for (var _a = 0, _b = toPath(key); _a < _b.length; _a++) {
        var segment = _b[_a];
        if (result == null) {
            return false;
        }
        if (!hasOwn$1.call(result, segment)) {
            return false;
        }
        result = result[segment];
    }
    return true;
};

var identity = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args[0];
};

var includes = function (array, target, fromIndex) {
    if (fromIndex === void 0) { fromIndex = 0; }
    if (Array.isArray(array)) {
        for (var i = fromIndex; i < array.length; i += 1) {
            if (target === array[i]) {
                return true;
            }
        }
    }
    return false;
};

var isEmpty = function (value) {
    return (value === null ||
        typeof (value === null || value === void 0 ? void 0 : value.length) === 'number' && !value.length ||
        typeof (value === null || value === void 0 ? void 0 : value.size) === 'number' && !value.size ||
        typeof value === 'object' && !Object.keys(value).length ||
        typeof value !== 'object');
};

var last = function (arg) {
    var array = arg;
    if (Array.isArray(array)) {
        return array[array.length - 1];
    }
    if (array && 'length' in array) {
        if (typeof array.length === 'number') {
            array = Array.from(array);
            return array[array.length - 1];
        }
    }
    if (array && 'size' in array) {
        // @ts-ignore
        if (typeof array.size === 'number') {
            array = Array.from(array);
            return array[array.length - 1];
        }
    }
    return undefined;
};

var mapValues = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var object = args[0], _a = args[1], customizer = _a === void 0 ? identity : _a;
    if (!object || typeof object !== 'object') {
        return {};
    }
    var result = {};
    for (var _b = 0, _c = Object.keys(object); _b < _c.length; _b++) {
        var key = _c[_b];
        result[key] = customizer(object[key], key, object);
    }
    return result;
};

var omit = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var object = args.shift();
    var props = args;
    var result = assign({}, object);
    for (var _a = 0, props_1 = props; _a < props_1.length; _a++) {
        var prop = props_1[_a];
        if (Array.isArray(prop)) {
            for (var _b = 0, prop_1 = prop; _b < prop_1.length; _b++) {
                var key = prop_1[_b];
                delete result[key];
            }
        }
        else {
            delete result[prop];
        }
    }
    return result;
};

var hasOwn = function (object, key) { return Object.prototype.hasOwnProperty.call(object, key); };
var pick = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = {};
    var object = args.shift();
    var props = args;
    for (var _a = 0, props_1 = props; _a < props_1.length; _a++) {
        var prop = props_1[_a];
        if (Array.isArray(prop)) {
            for (var _b = 0, prop_1 = prop; _b < prop_1.length; _b++) {
                var key = prop_1[_b];
                if (hasOwn(object, key)) {
                    // @ts-ignore
                    result[key] = object[key];
                }
            }
        }
        else {
            if (hasOwn(object, prop)) {
                // @ts-ignore
                result[prop] = object[prop];
            }
        }
    }
    return result;
};

function clone(value) {
    try {
        return JSON.parse(JSON.stringify(value));
    }
    catch (error) {
        if (Array.isArray(value)) {
            return [];
        }
        return {};
    }
}

function hasOnly(object, key) {
    return object && Object.keys(object).join(',') === key;
}

var ThunkState;
(function (ThunkState) {
    ThunkState[ThunkState["Pending"] = 0] = "Pending";
    ThunkState[ThunkState["Fulfilled"] = 1] = "Fulfilled";
    ThunkState[ThunkState["Rejected"] = 2] = "Rejected";
})(ThunkState || (ThunkState = {}));
var DEFAULT_THUNK_ERROR = new Error('thunk rejected');
function thunk(exeuctor) {
    var value;
    var reason;
    var state = ThunkState.Pending;
    var handlers;
    try {
        exeuctor(function (v) {
            state || (state = ThunkState.Fulfilled);
            value = v;
            notify(null, value);
        }, function (r) {
            state || (state = ThunkState.Rejected);
            reason = r !== null && r !== void 0 ? r : DEFAULT_THUNK_ERROR;
            notify(reason);
        });
    }
    catch (e) {
        state || (state = ThunkState.Rejected);
        reason = e;
        notify(reason);
    }
    return function (callback) {
        switch (state) {
            case ThunkState.Rejected:
                callback(reason);
                break;
            case ThunkState.Fulfilled:
                callback(null, value);
                break;
            default:
                (handlers !== null && handlers !== void 0 ? handlers : (handlers = [])).push(callback);
                break;
        }
    };
    function notify(arg1, arg2) {
        if (handlers) {
            for (var _i = 0, handlers_1 = handlers; _i < handlers_1.length; _i++) {
                var handler = handlers_1[_i];
                handler === null || handler === void 0 ? void 0 : handler(arg1, arg2);
            }
            handlers.length = 0;
            handlers = undefined;
        }
    }
}
thunk.resolve = thunkResolve;
thunk.reject = thunkReject;
function thunkResolve(value) {
    return function (callback) { return callback(null, value); };
}
function thunkReject(reason) {
    if (reason === void 0) { reason = DEFAULT_THUNK_ERROR; }
    return function (callback) { return callback(reason); };
}

function join() {
    var paths = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        paths[_i] = arguments[_i];
    }
    paths = paths.filter(Boolean);
    var startIdx = findLastIndex(paths, function (path) { return /^\//.test(path); });
    if (startIdx !== -1) {
        paths = paths.slice(startIdx);
    }
    return normalize(paths.join('/'));
}
function normalize(path) {
    var absolute = isAbsolute(path);
    path = (path
        .replace(/\/{2,}/g, '') /* adjacent slash */
        .replace(/(?:\.\/)+/g, '') /* adjacent dot slash */
        .replace(/\/+$/, '') /* trailing slash */);
    if (absolute) {
        if (!isAbsolute(path)) {
            return "/".concat(path);
        }
    }
    return path;
    // not use look behind for compatibility
    // return (
    //   path
    //     .replace(/(?<=\/)\/+/g, '') /* adjacent slash */
    //     .replace(/(?:\.\/)+/g, '') /* adjacent dot slash */
    //     .replace(/(?<!^)\/+$/, '') /* trailing slash */
    // )
}
function pathname$1(path) {
    return normalize(path);
}
function dirname(path) {
    path = pathname$1(path);
    var slashIdx = path.lastIndexOf('/');
    if (slashIdx === -1) {
        return path;
    }
    if (slashIdx === 0) {
        return '/';
    }
    return path.substring(0, slashIdx);
}
function isAbsolute(path) {
    return /^\//.test(path);
}

var noop = function () { };
function intercept(target, propertyKey, handlers) {
    var _a, _b, _c;
    var prevDesc = Object.getOwnPropertyDescriptor(target, propertyKey);
    if (prevDesc && !prevDesc.configurable) {
        return noop;
    }
    Object.defineProperty(target, propertyKey, {
        get: (handlers.get ?
            function () {
                var $super = {
                    get: function (target) { var _a; return (_a = prevDesc === null || prevDesc === void 0 ? void 0 : prevDesc.get) === null || _a === void 0 ? void 0 : _a.call(target); }
                };
                return handlers.get(this, $super);
            } :
            (_a = prevDesc === null || prevDesc === void 0 ? void 0 : prevDesc.get) !== null && _a !== void 0 ? _a : noop),
        set: (handlers.set ?
            function (value) {
                var $super = {
                    set: function (target, value) { var _a; return (_a = prevDesc === null || prevDesc === void 0 ? void 0 : prevDesc.set) === null || _a === void 0 ? void 0 : _a.call(target, value); }
                };
                handlers.set(this, value, $super);
            } :
            (_b = prevDesc === null || prevDesc === void 0 ? void 0 : prevDesc.set) !== null && _b !== void 0 ? _b : noop),
        enumerable: (_c = prevDesc === null || prevDesc === void 0 ? void 0 : prevDesc.enumerable) !== null && _c !== void 0 ? _c : false,
        configurable: true,
    });
    return function () {
        // reset
        if (prevDesc) {
            Object.defineProperty(target, propertyKey, prevDesc);
        }
        else {
            // @ts-ignore
            delete target[propertyKey];
        }
    };
}

function createArrayIterator(array) {
    if (array[Symbol === null || Symbol === void 0 ? void 0 : Symbol.iterator]) {
        return array[Symbol.iterator]();
    }
    var i = 0;
    return {
        next: function () {
            while (i < array.length) {
                return { done: false, value: array[i++] };
            }
            return { done: true, value: undefined };
        }
    };
}

function createTreeIterator(root) {
    var stacks = [];
    var stage = 0 /* IteratorStage.Enter */;
    return {
        next: function () {
            while (true) {
                if (stage === -1 /* IteratorStage.Exit */) {
                    return { done: true, value: undefined };
                }
                if (stage === 0 /* IteratorStage.Enter */) {
                    if (root.children) {
                        stage = 1 /* IteratorStage.BeforeVisit */;
                        stacks.push(createArrayIterator(root.children));
                    }
                    else {
                        stage = -1 /* IteratorStage.Exit */;
                    }
                    return { done: false, value: root };
                }
                if (stage === 1 /* IteratorStage.BeforeVisit */) {
                    var iterator = stacks[stacks.length - 1];
                    var _a = iterator.next(), done = _a.done, current = _a.value;
                    if (done) {
                        stage = 2 /* IteratorStage.AfterVisit */;
                        continue;
                    }
                    if (current.children) {
                        stage = 1 /* IteratorStage.BeforeVisit */;
                        stacks.push(createArrayIterator(current.children));
                    }
                    else {
                        stage = 2 /* IteratorStage.AfterVisit */;
                    }
                    return { done: false, value: current };
                }
                if (stage === 2 /* IteratorStage.AfterVisit */) {
                    stacks.pop();
                    if (!stacks.length) {
                        stage = -1 /* IteratorStage.Exit */;
                    }
                    continue;
                }
                // default
                return { done: true, value: undefined };
            }
        }
    };
}

function createRouteMatcher(options) {
    return new VueRouter(omit(options, ['routes'])).matcher;
}

function pathname(path) {
    return pathname$1(stripQuery(path));
}
function stripQuery(path) {
    var questionIdx = path.indexOf('?');
    if (questionIdx !== -1) {
        path = path.substring(0, questionIdx);
    }
    return path;
}

/**
 * Tokenize input string.
 */
function lexer(str) {
    var tokens = [];
    var i = 0;
    while (i < str.length) {
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({ type: "MODIFIER", index: i, value: str[i++] });
            continue;
        }
        if (char === "\\") {
            tokens.push({ type: "ESCAPED_CHAR", index: i++, value: str[i++] });
            continue;
        }
        if (char === "{") {
            tokens.push({ type: "OPEN", index: i, value: str[i++] });
            continue;
        }
        if (char === "}") {
            tokens.push({ type: "CLOSE", index: i, value: str[i++] });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while (j < str.length) {
                var code = str.charCodeAt(j);
                if (
                // `0-9`
                (code >= 48 && code <= 57) ||
                    // `A-Z`
                    (code >= 65 && code <= 90) ||
                    // `a-z`
                    (code >= 97 && code <= 122) ||
                    // `_`
                    code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name)
                throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({ type: "NAME", index: i, value: name });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") {
                throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            }
            while (j < str.length) {
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                }
                else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") {
                        throw new TypeError("Capturing groups are not allowed at ".concat(j));
                    }
                }
                pattern += str[j++];
            }
            if (count)
                throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern)
                throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({ type: "PATTERN", index: i, value: pattern });
            i = j;
            continue;
        }
        tokens.push({ type: "CHAR", index: i, value: str[i++] });
    }
    tokens.push({ type: "END", index: i, value: "" });
    return tokens;
}
/**
 * Parse a string for the raw tokens.
 */
function parse(str, options) {
    if (options === void 0) { options = {}; }
    var tokens = lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
    var defaultPattern = "[^".concat(escapeString(options.delimiter || "/#?"), "]+?");
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function (type) {
        if (i < tokens.length && tokens[i].type === type)
            return tokens[i++].value;
    };
    var mustConsume = function (type) {
        var value = tryConsume(type);
        if (value !== undefined)
            return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function () {
        var result = "";
        var value;
        while ((value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))) {
            result += value;
        }
        return result;
    };
    while (i < tokens.length) {
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || defaultPattern,
                modifier: tryConsume("MODIFIER") || "",
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || "",
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
/**
 * Escape a regular expression string.
 */
function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */
function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */
function regexpToRegexp(path, keys) {
    if (!keys)
        return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while (execResult) {
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: "",
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */
function arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function (path) { return pathToRegexp(path, keys, options).source; });
    return new RegExp("(?:".concat(parts.join("|"), ")"), flags(options));
}
/**
 * Create a path regexp from string input.
 */
function stringToRegexp(path, keys, options) {
    return tokensToRegexp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 */
function tokensToRegexp(tokens, keys, options) {
    if (options === void 0) { options = {}; }
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function (x) { return x; } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat(escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat(escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        if (typeof token === "string") {
            route += escapeString(encode(token));
        }
        else {
            var prefix = escapeString(encode(token.prefix));
            var suffix = escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys)
                    keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    }
                    else {
                        route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                    }
                }
                else {
                    if (token.modifier === "+" || token.modifier === "*") {
                        route += "((?:".concat(token.pattern, ")").concat(token.modifier, ")");
                    }
                    else {
                        route += "(".concat(token.pattern, ")").concat(token.modifier);
                    }
                }
            }
            else {
                route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
            }
        }
    }
    if (end) {
        if (!strict)
            route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    }
    else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string"
            ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1
            : endToken === undefined;
        if (!strict) {
            route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        }
        if (!isEndDelimited) {
            route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
        }
    }
    return new RegExp(route, flags(options));
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 */
function pathToRegexp(path, keys, options) {
    if (path instanceof RegExp)
        return regexpToRegexp(path, keys);
    if (Array.isArray(path))
        return arrayToRegexp(path, keys, options);
    return stringToRegexp(path, keys, options);
}

var RouteDispatcher = /** @class */ (function () {
    function RouteDispatcher() {
        this.nameRegistered = {};
        this.pathRegistered = {};
        this.pathRegExpRegistered = [];
    }
    RouteDispatcher.prototype.register = function (token, routes, parent, changedRoutes) {
        var _a, _b;
        var _c;
        if (parent === void 0) { parent = ''; }
        if (changedRoutes === void 0) { changedRoutes = []; }
        var _d = this, nameRegistered = _d.nameRegistered, pathRegistered = _d.pathRegistered, pathRegExpRegistered = _d.pathRegExpRegistered;
        for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
            var route = routes_1[_i];
            if (route.name) {
                (_a = nameRegistered[_c = route.name]) !== null && _a !== void 0 ? _a : (nameRegistered[_c] = token);
            }
            var path = join(parent, route.path);
            if (route.children) {
                this.register(token, route.children, path, changedRoutes);
                // continue
            }
            if (typeof route.path !== 'string') {
                continue;
            }
            if (includes(changedRoutes, route)) {
                (_b = pathRegistered[path]) !== null && _b !== void 0 ? _b : (pathRegistered[path] = token);
            }
            if (!route.children) {
                pathRegExpRegistered.push([pathToRegexp(path), token]);
            }
        }
    };
    RouteDispatcher.prototype.targetFor = function (location, current) {
        var _a;
        var _b = this, nameRegistered = _b.nameRegistered, pathRegistered = _b.pathRegistered, pathRegExpRegistered = _b.pathRegExpRegistered;
        // target by name
        var name = location.name;
        if (name && name in nameRegistered) {
            return nameRegistered[name];
        }
        // target by path
        var path = ((_a = location.path) !== null && _a !== void 0 ? _a : location);
        if (typeof path !== 'string') {
            return null;
        }
        path = pathname(path);
        if (!isAbsolute(path)) {
            if (current) {
                path = join(dirname(current.path), path);
            }
            else {
                path = "/".concat(path);
            }
        }
        if (path in pathRegistered) {
            return pathRegistered[path];
        }
        for (var _i = 0, pathRegExpRegistered_1 = pathRegExpRegistered; _i < pathRegExpRegistered_1.length; _i++) {
            var _c = pathRegExpRegistered_1[_i], pattern = _c[0], token = _c[1];
            if (pattern.test(path)) {
                return token;
            }
        }
        return null;
    };
    return RouteDispatcher;
}());

function isAsyncComponent(component) {
    return (typeof component === 'function' &&
        !('cid' in component));
}

function isComponent(component) {
    return (typeof component === 'function' &&
        'cid' in component);
}

function toConstructor(component, SuperComponent) {
    if (SuperComponent === void 0) { SuperComponent = Vue; }
    if (isComponent(component)) {
        return component;
    }
    if (isAsyncComponent(component)) {
        if (!component.resolved) {
            return SuperComponent;
        }
        return toConstructor(component.resolved, SuperComponent);
    }
    // already memoized in Vue.extend
    return SuperComponent.extend(component);
}

function toOptions(component, slowPath) {
    var _a, _b;
    if (slowPath === void 0) { slowPath = true; }
    if (!slowPath) {
        if (typeof component === 'object') {
            return component;
        }
    }
    // @ts-ignore
    return (_b = (_a = toConstructor(component)) === null || _a === void 0 ? void 0 : _a.options) !== null && _b !== void 0 ? _b : {};
}

function isOptionsFromClassComponent(options) {
    return (options &&
        hasCollectDataFromConstructorMixin(options));
}
function hasCollectDataFromConstructorMixin(options) {
    var mixin = options.mixins && last(options.mixins);
    return (mixin &&
        hasOnly(mixin, 'data') &&
        typeof mixin.data === 'function');
}

var INTERNAL_HOOKS = [
    'beforeCreate',
    'created',
    'beforeDestroy',
    'destroyed',
    'beforeMount',
    'mounted',
    'beforeUpdate',
    'updated',
    'activated',
    'deactivated',
    // 'errorCaptured',
];
function hasHookRegistered(componentOptions, name, hook) {
    // assume<InternalHookKey>(name)
    var _a, _b;
    return (typeof hook === 'function' &&
        (componentOptions[name] === hook ||
            // @ts-ignore
            ((_b = (_a = componentOptions[name]) === null || _a === void 0 ? void 0 : _a.indexOf) === null || _b === void 0 ? void 0 : _b.call(_a, hook)) > -1));
}

function toClass(component, SuperComponent) {
    if (SuperComponent === void 0) { SuperComponent = Vue; }
    var ProxyComponent = toConstructor(component, SuperComponent).extend();
    var componentOptions = toOptions(ProxyComponent);
    var rootOptions = toOptions(Vue);
    var methods = omit(componentOptions.methods, Object.keys(Vue.prototype));
    assign(ProxyComponent.prototype, methods);
    var _loop_1 = function (hook) {
        var instanceHooks = componentOptions[hook];
        ProxyComponent.prototype[hook] = function () {
            if (!instanceHooks) {
                return;
            }
            for (var _i = 0, _a = castArray(instanceHooks); _i < _a.length; _i++) {
                var instanceHook = _a[_i];
                if (hasHookRegistered(rootOptions, hook, instanceHook)) {
                    continue;
                }
                instanceHook.call(this);
            }
        };
    };
    for (var _i = 0, INTERNAL_HOOKS_1 = INTERNAL_HOOKS; _i < INTERNAL_HOOKS_1.length; _i++) {
        var hook = INTERNAL_HOOKS_1[_i];
        _loop_1(hook);
    }
    var render = componentOptions.render;
    ProxyComponent.prototype.render = function (h, reserved) {
        if (h === void 0) { h = this.$createElement; }
        return render === null || render === void 0 ? void 0 : render.call(this, h, reserved);
    };
    var extend = ProxyComponent.extend;
    ProxyComponent.extend = function (options) {
        var result = extend.call(this, options);
        if (isOptionsFromClassComponent(options)) {
            for (var _i = 0, INTERNAL_HOOKS_2 = INTERNAL_HOOKS; _i < INTERNAL_HOOKS_2.length; _i++) {
                var hook = INTERNAL_HOOKS_2[_i];
                // hook overriden
                if (typeof options[hook] === 'function') {
                    var rootHooks = rootOptions[hook] ? castArray(rootOptions[hook]) : [];
                    // @ts-ignore
                    result.options[hook] = rootHooks.concat(options[hook]);
                }
            }
            // delete no-op render to fallback to template if any
            if (!render && options.render === ProxyComponent.prototype.render) {
                delete options.render;
            }
        }
        return result;
    };
    return ProxyComponent;
}

function isFunctionalComponent(component) {
    return (typeof component === 'object' && component &&
        'functional' in component && component.functional);
}

function applyProvider(component, providers) {
    providers = castArray(providers);
    if (!(providers === null || providers === void 0 ? void 0 : providers[0])) {
        return component;
    }
    var _super, _base;
    return providers.reduce(function (prev, provider) { return provider(_super = toClass(prev), _base !== null && _base !== void 0 ? _base : (_base = _super)); }, component);
}

function isExtendedOptions(component) {
    return (typeof component === 'object' &&
        !!component && '_Ctor' in component);
}

function getComponent(registry, id) {
    var _a, _b, _c, _d;
    if (isComponent(registry)) {
        return (_a = registry.component(id)) !== null && _a !== void 0 ? _a : null;
    }
    if (isExtendedOptions(registry)) {
        return (_b = toConstructor(registry).component(id)) !== null && _b !== void 0 ? _b : null;
    }
    if ('components' in registry) {
        return (_d = (_c = registry.components) === null || _c === void 0 ? void 0 : _c[id]) !== null && _d !== void 0 ? _d : null;
    }
    return null;
}
function setComponent(registry, id, component, options) {
    var _a;
    if (!component) {
        return;
    }
    if (isComponent(registry)) {
        registry.component(id, toConstructor(component));
        return;
    }
    if (isExtendedOptions(registry)) {
        toConstructor(registry).component(id, toConstructor(component));
        return;
    }
    if ('components' in registry) {
        (_a = registry.components) !== null && _a !== void 0 ? _a : (registry.components = {});
        if (typeof (options === null || options === void 0 ? void 0 : options.set) === 'function') {
            options.set(registry.components, id, component);
        }
        else {
            registry.components[id] = component;
        }
        return;
    }
}

function getComponentThunk(registry, id) {
    var component = getComponent(registry, id);
    if (isAsyncComponent(component)) {
        return getAsyncComponentThunk(component);
    }
    return thunk.resolve(component);
}
function getAsyncComponentThunk(component, id, registry) {
    var _a, _b;
    var _c;
    if (component.error && component.errComp) {
        (_a = (_c = component.errComp).error) !== null && _a !== void 0 ? _a : (_c.error = true);
        return thunk.reject(component.errComp);
    }
    if (component.resolved) {
        return thunk.resolve(component.resolved);
    }
    // @ts-ignore
    return (_b = component._thunk) !== null && _b !== void 0 ? _b : (component._thunk = thunk(function (resolve, reject) {
        intercept(component, 'resolved', {
            get: function (target) {
                // @ts-ignore
                return target._resolved;
            },
            set: function (target, value) {
                // @ts-ignore
                target._resolved = value;
                resolve(value);
            },
        });
        intercept(component, 'error', {
            get: function (target) {
                // @ts-ignore
                return target._error;
            },
            set: function (target, value) {
                // @ts-ignore
                target._error = value;
                // @ts-ignore
                reject(value);
            },
        });
    }));
}

function patchComponent(registry, path, providers, options) {
    var _a;
    var separatorIdx = path.indexOf((_a = options === null || options === void 0 ? void 0 : options.separator) !== null && _a !== void 0 ? _a : '.');
    if (separatorIdx === -1) {
        patchOwnComponent(registry, path, providers, options);
        return;
    }
    var id = path.substring(0, separatorIdx);
    var nextPath = path.substring(separatorIdx + 1);
    getComponentThunk(registry, id)(function (error, component) {
        if (error) {
            // handle error
            return;
        }
        if (!component || isFunctionalComponent(component)) {
            return;
        }
        var childRegistry = component;
        patchComponent(childRegistry, nextPath, providers, options);
    });
}
function patchComponents(registry, providers, options) {
    for (var _i = 0, _a = Object.keys(providers); _i < _a.length; _i++) {
        var path = _a[_i];
        if (providers[path]) {
            patchComponent(registry, path, providers[path], options);
        }
    }
}
function patchOwnComponent(registry, id, providers, options) {
    getComponentThunk(registry, id)(function (error, component) {
        if (error) {
            // handle error
            return;
        }
        var targetComponent = applyProvider(component, providers);
        if (targetComponent) {
            setComponent(registry, id, targetComponent, options);
        }
    });
}
function patchOwnComponents(registry, providers, options) {
    for (var _i = 0, _a = Object.keys(providers); _i < _a.length; _i++) {
        var id = _a[_i];
        if (providers[id]) {
            patchOwnComponent(registry, id, providers[id], options);
        }
    }
}

function getNamedViews(options) {
    var result = {};
    if ('components' in options) {
        if (options.components) {
            for (var _i = 0, _a = Object.keys(options.components); _i < _a.length; _i++) {
                var name_1 = _a[_i];
                if (options.components[name_1]) {
                    result[name_1] = options.components[name_1];
                }
            }
        }
        return result;
    }
    if ('component' in options) {
        if (options.component) {
            result.default = options.component;
        }
        return result;
    }
    return result;
}

function createRouteOptionsWalker(routes) {
    var root = { path: '', children: castArray(routes) };
    var iterator = createTreeIterator(root);
    var skip = true;
    return {
        next: function () {
            if (skip) {
                skip = false;
                iterator.next();
            }
            return iterator.next();
        }
    };
}

function createRouteOptionsCompareWalker(source, referenceRoot, options) {
    var sourceWrapper = {
        path: '',
        node: {
            path: '',
            children: castArray(source)
        },
    };
    var referenceWrapper = {
        path: '',
        node: {
            path: '',
            children: castArray(referenceRoot)
        },
    };
    var walker = createRouteOptionsCompareWalkerNormalized(sourceWrapper, referenceWrapper, referenceWrapper, options);
    var skip = true;
    return {
        next: function () {
            if (skip) {
                skip = false;
                walker.next();
            }
            return walker.next();
        }
    };
}
function createRouteOptionsCompareWalkerNormalized(source, localRoot, globalRoot, options) {
    if (globalRoot === void 0) { globalRoot = localRoot; }
    var stage = 'BEFORE_SELF';
    var target;
    var childIterator;
    var childRouteWalker;
    return {
        next: function () {
            var _a;
            while (true) {
                if (stage === 'EXIT') {
                    return { done: true, value: undefined };
                }
                if (stage === 'BEFORE_SELF') {
                    var userGlobal = (_a = options === null || options === void 0 ? void 0 : options.preferGlobalRoot) === null || _a === void 0 ? void 0 : _a.call(options, source);
                    if (userGlobal) {
                        target = findRouteOption(source, globalRoot, options === null || options === void 0 ? void 0 : options.isMatch);
                    }
                    else {
                        target = findRouteOption(source, localRoot, options === null || options === void 0 ? void 0 : options.isMatch);
                    }
                    stage = 'AFTER_SELF';
                    return { done: false, value: [source, target] };
                }
                if (stage === 'AFTER_SELF') {
                    if (!source.node.children) {
                        stage = 'EXIT';
                        continue;
                    }
                    childIterator !== null && childIterator !== void 0 ? childIterator : (childIterator = createArrayIterator(source.node.children));
                    stage = 'BEFORE_CHILD';
                }
                if (stage === 'BEFORE_CHILD') {
                    var _b = childIterator.next(), done = _b.done, child = _b.value;
                    if (done) {
                        stage = 'EXIT';
                        continue;
                    }
                    childRouteWalker !== null && childRouteWalker !== void 0 ? childRouteWalker : (childRouteWalker = createRouteOptionsCompareWalkerNormalized({ node: child, path: join(source.path, child.path) }, target !== null && target !== void 0 ? target : localRoot, globalRoot, options));
                    stage = 'IN_CHILD';
                }
                if (stage === 'IN_CHILD') {
                    var result = childRouteWalker.next();
                    if (result.done) {
                        stage = 'AFTER_CHILD';
                        continue;
                    }
                    return result;
                }
                if (stage === 'AFTER_CHILD') {
                    childRouteWalker = undefined;
                    stage = 'BEFORE_CHILD';
                    continue;
                }
                // default
                return { done: true, value: undefined };
            }
        }
    };
}
function findRouteOption(source, target, predicate) {
    if (predicate === void 0) { predicate = function (source, target) { return source.path === target.path; }; }
    if (predicate(source, target)) {
        return target;
    }
    if (target.node.children) {
        for (var _i = 0, _a = target.node.children; _i < _a.length; _i++) {
            var child = _a[_i];
            var reference = { node: child, path: join(target.path, child.path) };
            var found = findRouteOption(source, reference, predicate);
            if (found) {
                return found;
            }
        }
    }
    return null;
}
// function* walkRouteTree(source, root) {
//   const target = findRouteOption(source, root)
//   yield [ source, target ]
//   if (source.node.children) {
//     for (const child of source.node.children) {
//       yield *walkRouteTree(
//         { node: child, path: join(source.path, child.path ) },
//         target ?? root
//       )
//     }
//   }
// }

var RoutePreprocessor = /** @class */ (function () {
    function RoutePreprocessor(router) {
        this.router = router;
    }
    RoutePreprocessor.prototype.processRoutes = function (routes) {
        var _a, _b, _c, _d;
        var walker = createRouteOptionsWalker(routes);
        var resetHandlers = [];
        var _loop_1 = function () {
            var _f = walker.next(), done = _f.done, options = _f.value;
            if (done) {
                return "break";
            }
            if ('extends' in options) {
                // @ts-ignore
                var extendName = (_a = options.extends) === null || _a === void 0 ? void 0 : _a.name;
                // @ts-ignore
                var extendPath = (_c = (_b = options.extends) === null || _b === void 0 ? void 0 : _b.path) !== null && _c !== void 0 ? _c : (typeof options.extends === 'string' ? options.extends : null);
                if (extendName) {
                    // @ts-ignore
                    var originalName_1 = options.name;
                    // @ts-ignore
                    options.name = extendName;
                    resetHandlers.push(function () {
                        // @ts-ignore
                        options.name = originalName_1 !== null && originalName_1 !== void 0 ? originalName_1 : options.name;
                    });
                }
                else if (extendPath) {
                    // @ts-ignore
                    var orignalPath_1 = options.path;
                    // @ts-ignore
                    options.path = options.extends.path;
                    resetHandlers.push(function () {
                        // @ts-ignore
                        options.path = orignalPath_1 !== null && orignalPath_1 !== void 0 ? orignalPath_1 : options.path;
                    });
                }
            }
        };
        while (true) {
            var state_1 = _loop_1();
            if (state_1 === "break")
                break;
        }
        var compareWalker = createRouteOptionsCompareWalker(routes, (_d = this.router.options.routes) !== null && _d !== void 0 ? _d : [], {
            preferGlobalRoot: function (source) {
                return ('name' in source.node ||
                    'extends' in source.node);
            },
            isMatch: function (source, target) {
                if ('name' in source.node) {
                    return source.node.name === target.node.name;
                }
                return source.path === target.path;
            }
        });
        var changedRoutes = [];
        while (true) {
            var _e = compareWalker.next(), done = _e.done, value = _e.value;
            if (done) {
                break;
            }
            var source = value[0], target = value[1];
            var context = {};
            if (target) {
                this.processRouteConfig(source.node, target.node, context);
                this.processRouteAssets(source.node);
            }
            // @ts-ignore
            if (!target || context.changed) {
                changedRoutes.push(source.node);
            }
        }
        for (var _i = 0, resetHandlers_1 = resetHandlers; _i < resetHandlers_1.length; _i++) {
            var handler = resetHandlers_1[_i];
            handler === null || handler === void 0 ? void 0 : handler();
        }
        return changedRoutes;
    };
    RoutePreprocessor.prototype.processRouteConfig = function (options, superOptions, output) {
        var _a;
        var ownComponents = getNamedViews(options);
        var superComponents = getNamedViews(superOptions);
        if (output) {
            output.changed || (output.changed = this.isValidRouteDirectOption(options.redirect));
        }
        defaults(options, superOptions);
        if (isEmpty(superComponents)) {
            return;
        }
        var components = pick(ownComponents, Object.keys(superComponents));
        if (output) {
            output.changed || (output.changed = !isEmpty(components));
        }
        // @ts-ignore
        options.components = assign({}, superComponents, components);
        if ('component' in options) {
            delete options.component;
        }
        var providers = ((_a = options.providers) !== null && _a !== void 0 ? _a : (options.provider && { default: options.provider }));
        if (!providers) {
            return;
        }
        providers = pick(providers, Object.keys(superComponents));
        providers = omit(providers, Object.keys(ownComponents));
        if (isEmpty(providers)) {
            return;
        }
        if (output) {
            output.changed = true;
        }
        // @ts-ignore
        patchOwnComponents(options, providers, {
            // @ts-ignore
            set: function (components, name, component) {
                Object.defineProperty(components, name, {
                    get: function () {
                        // @ts-ignore
                        return component;
                    },
                    // @ts-ignore
                    set: function (v) {
                    },
                    enumerable: true,
                    configurable: true,
                });
            }
        });
    };
    RoutePreprocessor.prototype.processRouteAssets = function (options) {
        var _a, _b;
        var assets = ((_a = options.assets) !== null && _a !== void 0 ? _a : (options.asset && { default: options.asset }));
        if (isEmpty(assets)) {
            return;
        }
        var _loop_2 = function (name_1) {
            // @ts-ignore
            if (!((_b = options.components) === null || _b === void 0 ? void 0 : _b[name_1])) {
                return "continue";
            }
            // @ts-ignore
            var componentThunk = getComponentThunk(options, name_1);
            var asset = assets[name_1];
            if (asset.providers) {
                componentThunk(function (err, component) {
                    if (!err) {
                        // @ts-ignore
                        patchComponents(component, asset.providers);
                    }
                });
            }
            if (asset.components) {
                componentThunk(function (err, component) {
                    if (!err) {
                        // @ts-ignore
                        patchComponents(component, mapValues(asset.components, function (component) { return function () { return component; }; }));
                    }
                });
            }
        };
        for (var _i = 0, _c = Object.keys(assets); _i < _c.length; _i++) {
            var name_1 = _c[_i];
            _loop_2(name_1);
        }
    };
    RoutePreprocessor.prototype.isValidRouteDirectOption = function (option) {
        return (typeof option === 'string' ||
            typeof option === 'function' ||
            typeof (option === null || option === void 0 ? void 0 : option.name) === 'string' ||
            typeof (option === null || option === void 0 ? void 0 : option.path) === 'string');
    };
    return RoutePreprocessor;
}());

function extendRouteMatcher(router) {
    var baseMatcher = router.matcher;
    var advancedMatcher = createRouteMatcher(router.options);
    var preprocessor = new RoutePreprocessor(router);
    var dispatcher = new RouteDispatcher();
    var token = "ADVANCED-".concat(Date.now());
    router.matcher = {
        match: function (raw, current, redirectedFrom) {
            if (token === dispatcher.targetFor(raw, current)) {
                return advancedMatcher.match(raw, current, redirectedFrom);
            }
            return baseMatcher.match(raw, current, redirectedFrom);
        },
        addRoutes: function (routes) {
            var changedRoutes = preprocessor.processRoutes(routes);
            // mergeRoutes(sharedRoutes ??= router.options.routes, routes)
            dispatcher.register(token, routes, '', changedRoutes);
            advancedMatcher.addRoutes(routes);
        },
        // @ts-ignore
        __preprocessor: preprocessor,
        // @ts-ignore
        __dispatcher: dispatcher,
        // @ts-ignore
        __base: baseMatcher,
        // @ts-ignore
        __advanced: advancedMatcher,
    };
}

function extendRouter(router) {
    extendRouteMatcher(router);
}

function getStartLocation(router) {
    var _a;
    // @ts-ignore
    return (_a = router.history._startLocation) !== null && _a !== void 0 ? _a : '';
}

function reloadRouter(router) {
    if (!router.app) {
        // not mounted yet
        return;
    }
    var startLocation = getStartLocation(router);
    // const component = last(currentRoute.matched)?.components?.default
    // if (component && isAsyncComponent(component)) {
    //   return
    // }
    // @ts-ignore
    if (router.history.pending) {
        var reloaded_1 = false;
        var unsubscribe_1 = router.beforeResolve(function (to, from, next) {
            if (reloaded_1) {
                return;
            }
            reloaded_1 = true;
            // next(false)
            unsubscribe_1 === null || unsubscribe_1 === void 0 ? void 0 : unsubscribe_1();
            if (startLocation) {
                doReloadRouter(withQuery(startLocation, ':ts', Date.now()), next);
            }
            else {
                doReloadRouter(to, next);
            }
        });
    }
    else {
        var next = router.push.bind(router);
        if (startLocation) {
            doReloadRouter(withQuery(startLocation, ':ts', Date.now()), next);
        }
        else {
            doReloadRouter(router.currentRoute, next);
        }
    }
}
function doReloadRouter(route, next) {
    // @ts-ignore
    if (route === null || route === void 0 ? void 0 : route.redirectedFrom) {
        // @ts-ignore
        route = route.redirectedFrom;
    }
    if (typeof route === 'string') {
        next(route);
    }
    else {
        next(refreshedRoute(route));
    }
}
function refreshedRoute(route) {
    // const location = pick(route, [ 'name', 'path', 'params', 'query', 'hash' ]) as Location
    var location = cloneLocation(route);
    location.query[':ts'] = String(Date.now());
    return location;
}
function cloneLocation(input) {
    var output = {};
    if (has(input, 'name')) {
        output.name = input.name;
    }
    if (has(input, 'path')) {
        output.path = input.path;
    }
    if (has(input, 'replace')) {
        output.replace = input.replace;
    }
    output.query = clone(input.query);
    output.params = clone(input.params);
    return output;
}
function withQuery(location, name, value) {
    var _a;
    return {
        path: location,
        query: (_a = {},
            _a[name] = value,
            _a)
    };
    // name = encodeURIComponent(name)
    // value = encodeURIComponent(value)
    // const questionIdx = location.indexOf('?')
    // const segment = `${name}=${value}`
    // if (questionIdx !== -1) {
    //   const start = location.substring(0, questionIdx + 1)
    //   const end = location.substring(questionIdx + 1).replace(new RegExp(`(?<=^|&)${name}(?:=[^&]+)?`), '')
    //   return `${start}${segment}&${end}`
    // }
    // const hashIdx = location.indexOf('#')
    // if (hashIdx !== -1) {
    //   const start = location.substring(0, hashIdx)
    //   const end = location.substring(hashIdx)
    //   return `${start}?${segment}&${end}`
    // }
    // return `${location}?${segment}`
}
var reload = reloadRouter;

function initStartLocation(router, location) {
    if (router.options.base) {
        var baseLowerCase = router.options.base.toLowerCase();
        var pathLowerCase = location.toLowerCase();
        if (!/\/$/.test(baseLowerCase)) {
            baseLowerCase = "".concat(baseLowerCase, "/");
        }
        if (pathLowerCase.substring(0, baseLowerCase.length) === baseLowerCase) {
            pathLowerCase = pathLowerCase.substring(baseLowerCase.length);
        }
        location = pathLowerCase;
    }
    // @ts-ignore
    router.history._startLocation = location;
}

export { extendRouter, initStartLocation, reload, reloadRouter };
//# sourceMappingURL=index.esm.js.map
